import type { FaireProductEntity } from "../../entity_types/product";

export const p_qkpaf7z22z: FaireProductEntity = {
  token: "p_qkpaf7z22z",
  type: "product",
  name: "Papa Cotton Vest (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/09030ea4eba4dfd8c52b243d05bde254a30c5d9c5b0d0c8f717b0630d1a6c5e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aef291d5f73758da43d23db62c738418c602856a04724216768ca69497296940.jpeg",
    "https://cdn.faire.com/fastly/aa8d7cd21394fdc595d7e25b358297141316833577fa26e63a2614f81b40f2be.jpeg",
    "https://cdn.faire.com/fastly/e013f95de49d19eeddaa1aaac1498651de42adcf38ddf638208ebcebb912dc47.jpeg",
  ],
  priceDollars: 220,
  description:
    'Why we made this?\n\nTimeless ease meets structural detail. Inspired by the beloved Granny Vest, the Papa Cotton Vest features an open-front silhouette with functional pockets adorning the front panels. A thoughtfully refined fit offers a slightly shorter length and soft, relaxed drape. A modern take on a lived-in staple, it is designed to layer effortlessly over your favorite foundation pieces.\n\nContents: \n\n70% Cotton, 27% Nylon, 3% Spandex\n\nMade in South Korea\n\n\n\nCare Instructions:\n\nHand wash in cold water\n\nTowel dry & lay flat to dry\n\n\n\nApproximate Measurements: \n\nXS/S: Length 19 1/2", Back chest 20 1/2"\n\nM/L: Length: 20", Back chest: 22" \n\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S \n\n\n\nMSRP: $115 USD\n',
  tags: [],
  msrpDollars: 440,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:51.430Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
